import { FunctionComponent, useEffect, useState } from 'react';
import { Button, IconButton } from '../../tailwindcomponents';
import { Typography } from '../../tailwindcomponents';
import lineApi from '../../api/line';
import { redirectToMxi } from '../../config/mxiProvider';
import { Link } from '../../components/icons';
import { MxiEventsForUsersPackageOverviewByTailNUmber } from '../../types/line';

interface LineHandoverMxiPackageInformationProps {
    tabValue: number,
    reportId: number
}
const LineHandoverMxiPackageInformation: FunctionComponent<LineHandoverMxiPackageInformationProps> = ({ tabValue, reportId }) => {
    const [mxiEvents, setMxiEvents] = useState(Array<MxiEventsForUsersPackageOverviewByTailNUmber>());

    useEffect(() => {
        const isTurnCheck = tabValue === 2 ? true : false;
        lineApi.GetMxiEventsForShift(reportId, isTurnCheck).then(res => {
            setMxiEvents(res.data);
        });
    }, [tabValue]);

    if (tabValue !== 0) {
        return (
            <div>
                <div className="flex flex-wrap">
                    {mxiEvents.map(aircraft => (
                        <div>
                            <Typography text={aircraft.tail_number} variant='h2' fontWeight='bolder' />
                            {
                                aircraft.packages.map((wo, index) => (
                                    <div >
                                        <div className="flex flex-wrap">
                                            <Typography text={index + 1} margin={[0, 2, 0, 0]} />
                                            <Typography text={wo.wo_name} textColor='black' margin={[0, 2, 0, 0]} />
                                            <Typography text={wo.wo_status} textColor={wo.wo_status_color} />
                                            <Button variant="text" className="-mt-[15px]" onClick={() => redirectToMxi(wo.wo_barcode)}><IconButton><Link color="primary" /></IconButton></Button>
                                        </div>
                                        {
                                            wo.mxiEvents.map(task => (
                                                <div className="flex flex-wrap">
                                                    <Typography text={"-"} fontWeight={'bolder'} margin={[0, 2, 0, 2]} />
                                                    <Typography text={task.task_name} textColor='black' />
                                                    <Typography text={task.action_taken_text} textColor='black' />
                                                    <Typography text={"perf. by"} margin={[0, 1, 0, 1]} textColor='black' />
                                                    <Typography text={task.employee_name} textColor='black' />
                                                    <Typography text={"AT"} margin={[0, 1, 0, 1]} textColor={"black"} />
                                                    <Typography text={task.action_taken_date.toString()} textColor='black' />
                                                </div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    ))}
                </div>
            </div>
        );
    } else {
        return (
            <p></p>
        );
    }
};
export default LineHandoverMxiPackageInformation;